/**
 * Used to communicate whether a contextual tab is part of a tab group
 * and whether it is the first or last tab in that group. We use this to inform
 * some high contrast styling
 */
export enum ConnectedTabState {
  None = 0,
  First = 1,
  Last = 2,
}
